import { TFunction } from "i18next";
import * as yup from "yup";
import { InferType } from "yup";

const educationalResourceValidationSchema = (t: TFunction) =>
  yup.object().shape({
    categoryId: yup.string().required("This field is required"),
    type: yup
      .string()
      .required("This field is required")
      .oneOf(["VIDEO", "AUDIO", "PDF", "WEB", "IMAGE"], "Invalid type"),
    status: yup
      .string()
      .required("This field is required")
      .oneOf(["ACTIVE", "INACTIVE"], "Invalid status"),
    thumbnailUrl: yup.string().default(""),
    duration: yup
      .number()
      .typeError("Duration must be a number")
      .transform((value, original) =>
        original === "" || original === null || original === undefined
          ? undefined
          : value
      )
      .min(0, "Duration must be 0 or greater")
      .nullable()
      .optional(),
    languages: yup
      .array()
      .of(
        yup.object().shape({
          _id: yup.string().optional(),
          language: yup
            .string()
            .required("Language is required")
            .min(2, t("validations.min_length", { count: 2 })),
          title: yup
            .string()
            .required("Title is required")
            .max(200, t("validations.max_length", { count: 200 })),
          description: yup
            .string()
            .required("Description is required")
            .max(1000, t("validations.max_length", { count: 1000 })),
          url: yup.string().required("URL is required"),
        })
      )
      .min(1, "Add at least one language")
      .required("This field is required"),
  });

export type EducationalResourceFormData = InferType<
  ReturnType<typeof educationalResourceValidationSchema>
>;

export default educationalResourceValidationSchema;
